var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAigradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1000,
    viewBox: "0 0 1440 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_2570_27761)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.191,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#FFEBA9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.202,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#FFD2A9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 990.446,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#E760EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 867.137,
    cy: 443.274,
    rx: 220.553,
    ry: 258.726,
    fill: "#EA6081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2570_27761",
    x: -210.674,
    y: -255.877,
    width: 1861.99,
    height: 1398.19,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 220.156,
    result: "effect1_foregroundBlur_2570_27761"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAigradient);
export default __webpack_public_path__ + "static/media/Aigradient.fd5ab162070e81ea2bf8471000010955.svg";
export { ForwardRef as ReactComponent };